<!-- src/app/pages/events/events.component.html -->
<section class="events-page">
  <div class="container">

    <!-- HERO -->
    <div class="hero">
      <h1>Events</h1>
      <p class="hero-sub">
        Join Lydia across Michigan. Town halls, canvassing events, and community meetings - open to everyone.
      </p>
    </div>

    <!-- MOBILIZE WIDGET (live once mobilizeOrgId is set in events.component.ts) -->
    <div class="mobilize-wrapper">
      <div id="mobilize-widget"></div>
    </div>

    <!-- UPCOMING EVENTS -->
    <div class="static-events">
      <h2 class="section-heading">Upcoming Events</h2>

      <div *ngIf="upcomingEvents.length > 0; else noUpcoming" class="event-list">
        <div *ngFor="let event of upcomingEvents" class="event-card">
          <div class="event-card__type event-card__type--{{ event.type }}">
            {{ event.type === 'signature-drive' ? '✍️ Signature Drive' :
               event.type === 'town-hall'       ? '🏛️ Town Hall' :
               event.type === 'canvass'         ? '🚪 Canvassing' :
               event.type === 'phone-bank'      ? '📞 Phone Bank' :
               event.type === 'rally'           ? '📢 Rally' : '📅 Event' }}
          </div>
          <div class="event-card__body">
            <h3 class="event-card__title">{{ event.title }}</h3>
            <div class="event-card__badges">
              <span *ngIf="event.virtual" class="badge badge--virtual">🖥️ Virtual</span>
              <span *ngIf="event.recurring" class="badge badge--recurring">🔁 Recurring</span>
            </div>
            <div class="event-card__meta">
              <span>📅 {{ event.displayDate }}</span>
              <span>🕐 {{ event.time }}</span>
              <span *ngIf="!event.virtual">📍 {{ event.location }}{{ event.city ? ', ' + event.city : '' }}</span>
            </div>
            <p class="event-card__desc">{{ event.description }}</p>
            <div *ngIf="event.partnerName" class="event-card__partner">
              Co-hosted with
              <a *ngIf="event.partnerUrl" [href]="event.partnerUrl" target="_blank" rel="noopener noreferrer">{{ event.partnerName }}</a>
              <span *ngIf="!event.partnerUrl">{{ event.partnerName }}</span>
            </div>
            <div class="event-card__actions">
  <a *ngIf="event.rsvpUrl"
     [href]="event.rsvpUrl"
     target="_blank"
     rel="noopener noreferrer"
     class="btn-primary">
    RSVP
  </a>

  <a [href]="getGoogleCalendarUrl(event)"
     target="_blank"
     rel="noopener noreferrer"
     class="btn-secondary">
    📅 Add to Calendar
  </a>
</div>
          </div>
        </div>
      </div>

      <ng-template #noUpcoming>
        <p class="no-events">No upcoming events scheduled right now. Check back soon or join the weekly organizing call.</p>
      </ng-template>
    </div>

    <!-- PAST EVENTS (collapsible) -->
    <div *ngIf="pastEvents.length > 0" class="static-events past-events-section">
      <button class="past-toggle" (click)="showPastEvents = !showPastEvents">
        {{ showPastEvents ? '▲ Hide Past Events' : '▼ Show Past Events (' + pastEvents.length + ')' }}
      </button>

      <div *ngIf="showPastEvents" class="event-list event-list--past">
        <div *ngFor="let event of pastEvents" class="event-card event-card--past">
          <div class="event-card__type event-card__type--{{ event.type }}">
            {{ event.type === 'signature-drive' ? '✍️ Signature Drive' :
               event.type === 'town-hall'       ? '🏛️ Town Hall' :
               event.type === 'canvass'         ? '🚪 Canvassing' :
               event.type === 'phone-bank'      ? '📞 Phone Bank' :
               event.type === 'rally'           ? '📢 Rally' : '📅 Event' }}
          </div>
          <div class="event-card__body">
            <h3 class="event-card__title">{{ event.title }}</h3>
            <div class="event-card__meta">
              <span>📅 {{ event.displayDate }}</span>
              <span>🕐 {{ event.time }}</span>
              <span *ngIf="!event.virtual">📍 {{ event.location }}{{ event.city ? ', ' + event.city : '' }}</span>
            </div>
            <p class="event-card__desc">{{ event.description }}</p>
          </div>
        </div>
      </div>
    </div>

    <!-- INVITE LYDIA FORM -->
    <div class="invite-section">
      <h2>Invite Lydia to Your Event</h2>
      <p class="invite-intro">
        Hosting a community gathering, town hall, or local event? Invite Lydia to attend.
        Fill out the form below and her team will be in touch.
      </p>

      <form
        #inviteForm="ngForm"
        (ngSubmit)="onInviteSubmit()"
        *ngIf="!inviteSubmitted"
        class="invite-form"
      >
        <div class="form-row">
          <div class="form-group">
            <label for="inv-name">Your Name *</label>
            <input id="inv-name" name="name" type="text" placeholder="Full Name"
              required [(ngModel)]="invite.name" #invName="ngModel"
              [disabled]="inviteSubmitting" />
            <div *ngIf="invName.invalid && invName.touched" class="error">Name is required.</div>
          </div>
          <div class="form-group">
            <label for="inv-email">Your Email *</label>
            <input id="inv-email" name="email" type="email" placeholder="Email Address"
              required pattern="[a-z0-9._%+\-]+@[a-z0-9.\-]+\.[a-z]{2,}$"
              [(ngModel)]="invite.email" #invEmail="ngModel"
              [disabled]="inviteSubmitting" />
            <div *ngIf="invEmail.invalid && invEmail.touched" class="error">
              <span *ngIf="invEmail.errors?.['required']">Email is required.</span>
              <span *ngIf="invEmail.errors?.['pattern']">Enter a valid email.</span>
            </div>
          </div>
        </div>

        <div class="form-group">
          <label for="inv-org">Organization or Group <span class="optional">(optional)</span></label>
          <input id="inv-org" name="organization" type="text" placeholder="e.g. Iron Range GSA, UAW Local 600"
            [(ngModel)]="invite.organization" [disabled]="inviteSubmitting" />
        </div>

        <div class="form-row">
          <div class="form-group">
            <label for="inv-event-name">Event Name *</label>
            <input id="inv-event-name" name="eventName" type="text" placeholder="Event Name"
              required [(ngModel)]="invite.eventName" #invEventName="ngModel"
              [disabled]="inviteSubmitting" />
            <div *ngIf="invEventName.invalid && invEventName.touched" class="error">Event name is required.</div>
          </div>
          <div class="form-group">
            <label for="inv-date">Event Date *</label>
            <input id="inv-date" name="eventDate" type="date"
              required [(ngModel)]="invite.eventDate" #invDate="ngModel"
              [disabled]="inviteSubmitting" />
            <div *ngIf="invDate.invalid && invDate.touched" class="error">Date is required.</div>
          </div>
        </div>

        <div class="form-row">
          <div class="form-group">
            <label for="inv-time">Event Time <span class="optional">(optional)</span></label>
            <input id="inv-time" name="eventTime" type="text" placeholder="e.g. 2:00 PM – 5:00 PM"
              [(ngModel)]="invite.eventTime" [disabled]="inviteSubmitting" />
          </div>
          <div class="form-group">
            <label for="inv-attendance">Expected Attendance <span class="optional">(optional)</span></label>
            <input id="inv-attendance" name="attendance" type="text" placeholder="e.g. 50–100 people"
              [(ngModel)]="invite.attendance" [disabled]="inviteSubmitting" />
          </div>
        </div>

        <div class="form-group">
          <label for="inv-location">Event Location *</label>
          <input id="inv-location" name="eventLocation" type="text" placeholder="Address or 'Virtual'"
            required [(ngModel)]="invite.eventLocation" #invLocation="ngModel"
            [disabled]="inviteSubmitting" />
          <div *ngIf="invLocation.invalid && invLocation.touched" class="error">Location is required.</div>
        </div>

        <div class="form-group">
          <label for="inv-details">Tell Us About Your Event *</label>
          <textarea id="inv-details" name="details" rows="4"
            placeholder="What is the event about? Why would you like Lydia to attend?"
            required [(ngModel)]="invite.details" #invDetails="ngModel"
            [disabled]="inviteSubmitting"></textarea>
          <div *ngIf="invDetails.invalid && invDetails.touched" class="error">Please describe your event.</div>
        </div>

        <button type="submit" class="btn-primary"
          [disabled]="inviteForm.invalid || inviteSubmitting">
          {{ inviteSubmitting ? 'Sending...' : 'Send Invitation' }}
        </button>
        <div *ngIf="inviteError" class="error submit-error">{{ inviteError }}</div>
      </form>

      <div *ngIf="inviteSubmitted" class="success-message">
        <p>Your invitation has been received! Lydia's team will review it and be in touch soon.</p>
        <button type="button" class="btn-secondary" (click)="resetInviteForm()">Submit Another</button>
      </div>
    </div>

  </div>
</section>
